import React, { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import './PageHeader.css';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { Box, SvgIconTypeMap } from '@mui/material';

interface PageHeaderProps {
  iconName?: IconProp;
  headerName: ReactNode;
  src?: string;
  size?: string;
  MuiIcon?: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
}

const PageHeader: React.FC<PageHeaderProps> = ({ iconName, headerName, src, size = '1.5rem', MuiIcon }) => {
  return (
    <Box sx={{ backgroundColor: 'rgb(250, 250, 250)' }} className="page-header-container">
      {MuiIcon && <MuiIcon className="page-header-icon" />}
      {iconName && <FontAwesomeIcon className="page-header-icon" icon={iconName} />}
      {src && <img src={src} style={{ width: size, height: size }} alt="header image" className="custom-image" />}
      <span className="page-header-name">{headerName}</span>
    </Box>
  );
};

export default PageHeader;
